/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, Input, ChangeDetectionStrategy, output, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from 'nebula-ui-kit';

@Component({
  selector: 'app-form-card',
  standalone: true,
  imports: [CommonModule, IconComponent],
  template: `
    <div class="form-card" [class.collapsed]="!expanded">
      <div
        class="card-header"
        (click)="toggleCollapse()"
        (keydown.enter)="toggleCollapse()"
        (keydown.space)="toggleCollapse(); $event.preventDefault()"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="expanded"
        [attr.aria-label]="expanded ? 'Colapsar panel' : 'Expandir panel'"
      >
        <div class="header-left">
          @if (icon) {
            <lib-icon [name]="$any(icon)" class="card-icon" aria-hidden="true" />
          }
          <h2>{{ title }}</h2>
        </div>
        <div class="header-actions">
          <ng-content select="[card-actions]"></ng-content>
          <button
            type="button"
            class="toggle-btn"
            [attr.aria-label]="expanded ? 'Colapsar' : 'Expandir'"
          >
            <lib-icon
              [name]="$any(expanded ? 'ChevronUp' : 'ChevronDown')"
              class="toggle-icon"
              aria-hidden="true"
            />
          </button>
        </div>
      </div>

      @if (expanded) {
        <div class="card-body">
          <ng-content></ng-content>
        </div>
      }
    </div>
  `,
  styleUrls: ['./form-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormCardComponent {
  @Input({ required: true }) title: string = '';
  @Input() icon?: string;
  @Input() expanded: boolean = false;

  cardToggle = output<boolean>();

  toggleCollapse(): void {
    this.cardToggle.emit(!this.expanded);
  }

  @HostListener('keydown.enter', ['$event'])
  @HostListener('keydown.space', ['$event'])
  onKeyPress(event: Event): void {
    event.preventDefault();
    this.toggleCollapse();
  }
}
